<template>
  <div id="project">

  <v-card class="utils" v-if="isOwner || !proj.uuid">
    <v-card-subtitle v-if="isOwner">You are the owner of this project</v-card-subtitle>
    <div v-if="editor && !proj.uuid">Creating a new project</div>
    <v-card-actions>
      <v-btn v-if="!editor" @click='newProj'>New Project</v-btn>
      <v-btn v-if="!editor && proj.uuid" @click='edit'>Edit</v-btn>
    </v-card-actions>
  </v-card>

<v-card v-if="editor">
  <v-card-title>Edit Project Details</v-card-title>
  <v-card-text>
    <SchemaForm :model="proj" item="project" v-on:save="save" v-on:cancel="refresh"/>
  </v-card-text>
</v-card>
<v-card v-if="editor">
  <v-card-subtitle v-if="!proj.uuid">
    <h2 class="center">Save new project to add attachments</h2>
  </v-card-subtitle>
  <v-card-text>
    <FileUpload v-if="editor && proj.uuid" :parent="proj" :uuid="0"/>
  </v-card-text>
</v-card>

<v-card v-if="false && editor">
  <v-card-text>
    <DataPreview :rec="proj" />
  </v-card-text>
</v-card>

<v-card v-if="!editor">
  <v-card-title>{{ proj.title}}</v-card-title>
  <v-card-text v-html="proj.content">
  </v-card-text>
</v-card>

<v-card v-if="!editor">
  <v-card-text>
    <ProjFunds :proj="proj"/>
  </v-card-text>
</v-card>
  </div>
</template>
<style scoped>
.center {
    text-align: center;
}
.v-application--wrap {
    min-height: 100px;
}
#project {
  margin-top: 2em;
}
</style>

<script>

import _ from 'lodash'
import router from '../plugins/router'
import axios from '../lib/axios'
//import Content from './Content.vue'
import ProjFunds from './ProjFunds.vue'
import FileUpload from './FileUpload.vue'
import DataPreview from './DataPreview.vue'
import SchemaForm from './SchemaForm.vue'

var log = console.log;
import schema from '../lib/schema/project.json'

export default {
    components: {
//      Content,
      SchemaForm,
      ProjFunds,
      FileUpload,
      DataPreview
    },
    data: function() { 
        return {
            docs : {},
            schema : schema,
            proj : {
                uuid : this.$route.params.uuid,
                title : '',
                name : '',
                content : '',
                owner : '',
                date_started : '',
                date_target : '',
                fund_size : '',
                goal : ''
            },
            invest : {
                total : 0
            },
            editor : false,
        }
    },
    created: function() {
        if (this.proj.uuid === 0) { // from route parameter
            this.edit()
        } else if (this.proj.uuid) {
            //this.$store.commit('data', 'route_projId', this.proj.uuid)
            this.$store.commit('route_projId', this.proj.uuid)
            this.getProject();
        } else if (this.projId) { // from cache
            this.proj.uuid = this.projId
            this.getProject();
        }
    },
    computed: {
        isOwner : function() {
            return this.$store.getters.uuid == this.proj._owner
        },
        projId : function() {
            return this.$store.getters.route_projId || ''
        }
    },
    methods: {
        refresh : function() {
            this.editor = false
            if (!this.proj.uuid) { 
                router.push({ name: 'Projects'})
                return
            }
            this.getProject()
        },
        edit : function() {
            this.editor = true
        },
        getProject : function() {
            var self = this;
            axios.get('/api/docs/'+ this.proj.uuid)
            .then(function (response) {
                var d = response.data;
                if (d.status!="success") {
                    throw d;
                }
                self.proj = response.data.data;
            })
            .catch((err) => {
                log('ERROR','project:getProjects', err.message)
                if (err.message.includes('504')) {
                    _.delay(this.refresh,300)
                } else {
self.$store.commit('showMessage', { content: err.message||"ERROR", color: 'error' })

                }
            });
      },
      newProj : function() {
        this.proj = {uuid : ''}
        this.edit()
      },
      save: function(d) {
          let data = {...this.proj, ...d}
          let self = this

            axios.post('/api/project/'+(data.uuid||0),
                data
            ).then(function(r){
                let x = r.data
                if (x.status != "success") throw (x.message || "UNKOWN")
                self.proj = x.data
                self.refresh()
                if (!confirm("Your project is saved. OK to return to view mode, or Cancel to stay in editor.")) {
                        self.edit()
                }
            })
            .catch(function(e){
                console.log('ERROR','Project:save', 'Attempt failed', e);
                self.$store.commit('showMessage', { content: e.message||"ERROR", color: 'error' })
            });

      }
  }
}
</script>

